module.exports = __webpack_public_path__ + "assets/img/aicon9.345d379d.png";